import React, { useState, useEffect } from "react";
import { Container, Row, Col, Form, Spinner } from "react-bootstrap";
import { useSelector } from "react-redux";
import axios from "axios";
import BreadCrumb from "../../components/breadcrumb/BreadCrumb";
import Notification from "../../../components/common/notification/Notification";
import LeaseNotes from "./LeaseNotes";

const LeaseNotesPage = () => {
  const authState = useSelector((state) => state.auth);
  const loggedInUser = authState?.user ?? authState;
  const token = loggedInUser?.refreshToken || authState?.refreshToken || loggedInUser?.token || authState?.token;
  const baseUrl = process.env.REACT_APP_BASE_URL;

  const [leases, setLeases] = useState([]);
  const [selectedLeaseId, setSelectedLeaseId] = useState("");
  const [loadingLeases, setLoadingLeases] = useState(true);

  useEffect(() => {
    const fetchLeases = async () => {
      setLoadingLeases(true);
      try {
        const response = await axios.post(
          `${baseUrl}/lease/all`,
          { page_number: 1, page_size: 100, order_by: "DESC" },
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${token}`,
            },
          }
        );

        const resData = response.data;
        const list =
          resData?.leases ||
          resData?.data ||
          resData?.content ||
          resData?.leaseList ||
          (Array.isArray(resData) ? resData : []);

        setLeases(list);
        if (list.length > 0) {
          setSelectedLeaseId(String(list[0].id));
        }
      } catch (err) {
        console.error("Error fetching leases for notes page:", err);
      } finally {
        setLoadingLeases(false);
      }
    };

    fetchLeases();
  }, [baseUrl, token]);

  const breadcrumbItems = [
    { label: "", link: "/admin", icon: "fa-solid fa-house" },
    { label: "Lease Management", link: "/lease" },
    { label: "Lease Notes", link: "/lease-notes", active: true },
  ];

  return (
    <>
      <Notification />
      <div className="content-body2">
        <Container>
          <BreadCrumb items={breadcrumbItems} />

          <Row className="mt-3 align-items-center">
            <Col md={6}>
              <h4 className="fw-semibold text-dark mb-0">Lease Notes Management</h4>
              <p className="text-muted mb-0 small">Select a lease to view, add, or manage notes.</p>
            </Col>

            <Col md={6} className="d-flex justify-content-md-end mt-3 mt-md-0">
              <div className="d-flex align-items-center gap-2" style={{ minWidth: "280px" }}>
                <Form.Label className="mb-0 fw-semibold text-nowrap text-secondary">
                  Select Lease:
                </Form.Label>
                {loadingLeases ? (
                  <Spinner animation="border" size="sm" variant="primary" />
                ) : (
                  <Form.Select
                    size="sm"
                    value={selectedLeaseId}
                    onChange={(e) => setSelectedLeaseId(e.target.value)}
                    style={{ fontWeight: "500" }}
                  >
                    {leases.length === 0 ? (
                      <option value="">No Leases Available</option>
                    ) : (
                      leases.map((l) => (
                        <option key={l.id} value={l.id}>
                          {l.title || `Lease #${l.id}`}
                        </option>
                      ))
                    )}
                  </Form.Select>
                )}
              </div>
            </Col>
          </Row>

          <Row className="mt-2">
            <Col lg={12}>
              {selectedLeaseId ? (
                <LeaseNotes leaseId={selectedLeaseId} />
              ) : (
                <div className="text-center py-5 bg-white rounded border shadow-sm mt-3">
                  <p className="text-muted mb-0">No lease selected. Please select a lease from the dropdown above.</p>
                </div>
              )}
            </Col>
          </Row>
        </Container>
      </div>
    </>
  );
};

export default LeaseNotesPage;
